import CarvanaLoadingSpinner from '@carvana/loading-spinner';
import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import cx from 'classnames';
import { useContext, useEffect, useState } from 'react';
import SpinnerContext from '~/context/vdp/SpinnerContext';

enum State {
  Hide,
  Remove,
  Show
}

function useLoaderState() {
  const {
    spinnerReady: { isLoading }
  } = useContext(SpinnerContext);
  const [state, setState] = useState(isLoading ? State.Show : State.Remove);

  useSubsequentEffect(() => {
    setState(isLoading ? State.Show : State.Hide);
  }, [isLoading]);

  // Remove loader after it is hidden
  useEffect(() => {
    if (state !== State.Hide) return () => {};

    const t = window.setTimeout(() => {
      setState(State.Remove);
    }, 1000);

    return () => {
      clearTimeout(t);
    };
  }, [state]);

  return state;
}

function LoadingSpinner() {
  const loaderState = useLoaderState();

  if (loaderState === State.Remove) return null;

  return (
    <CarvanaLoadingSpinner
      className={cx(
        'absolute transition-opacity duration-500 m:h-full',
        loaderState === State.Show ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}

export default LoadingSpinner;
